import type { Event } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useCancelEventMutation } from '../queries';

export const useCancelEvent = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: cancelEvent } = useCancelEventMutation();

  const confirm = useCallback(
    ({ event }: { event: Event }) => {
      const handleDeleteEvent = async () => {
        await cancelEvent(
          { eventId: event.id },
          {
            onSuccess() {
              message.success('Event canceled successfully');
            },
          },
        );
      };

      modal.confirm({
        content: 'This action is irreversible!',
        icon: <Icon color="error" icon="delete-2-line" />,
        okText: 'Cancel event',
        onOk: handleDeleteEvent,
        title: t('Are you sure you want to cancel {{name}}?', { name: event.name }),
        type: 'error',
      });
    },
    [cancelEvent, modal, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
